/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminDeleteBannerByBannerUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminDeleteBannerByBannerUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminGetBannersInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetBannersOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchBannerConflictDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchBannerInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchBannerNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchBannerOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchBannerReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminPostBannerCreatedDto } from '../../src/model';
// @ts-ignore
import type { AdminPostBannerInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPostBannerReqBodyDto } from '../../src/model';
// @ts-ignore
import type { CreateWithTargetUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminBannersApi - axios parameter creator
 * @export
 */
export const AdminBannersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 어드민 배너 삭제
         * @param {string} bannerUuid 배너 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBannerControllerAdminDeleteBannerByBannerUuid: async (bannerUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bannerUuid' is not null or undefined
            assertParamExists('adminBannerControllerAdminDeleteBannerByBannerUuid', 'bannerUuid', bannerUuid)
            const localVarPath = `/admin/banners/{bannerUuid}`
                .replace(`{${"bannerUuid"}}`, encodeURIComponent(String(bannerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 배너 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBannerControllerAdminGetBanners: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 배너 수정
         * @param {string} bannerUuid 배너 uuid
         * @param {AdminPatchBannerReqBodyDto} adminPatchBannerReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBannerControllerAdminPatchBannerByBannerUuid: async (bannerUuid: string, adminPatchBannerReqBodyDto: AdminPatchBannerReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bannerUuid' is not null or undefined
            assertParamExists('adminBannerControllerAdminPatchBannerByBannerUuid', 'bannerUuid', bannerUuid)
            // verify required parameter 'adminPatchBannerReqBodyDto' is not null or undefined
            assertParamExists('adminBannerControllerAdminPatchBannerByBannerUuid', 'adminPatchBannerReqBodyDto', adminPatchBannerReqBodyDto)
            const localVarPath = `/admin/banners/{bannerUuid}`
                .replace(`{${"bannerUuid"}}`, encodeURIComponent(String(bannerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchBannerReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 배너 생성
         * @param {AdminPostBannerReqBodyDto} adminPostBannerReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBannerControllerAdminPostBanner: async (adminPostBannerReqBodyDto: AdminPostBannerReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPostBannerReqBodyDto' is not null or undefined
            assertParamExists('adminBannerControllerAdminPostBanner', 'adminPostBannerReqBodyDto', adminPostBannerReqBodyDto)
            const localVarPath = `/admin/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPostBannerReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminBannersApi - functional programming interface
 * @export
 */
export const AdminBannersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminBannersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 어드민 배너 삭제
         * @param {string} bannerUuid 배너 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBannerControllerAdminDeleteBannerByBannerUuid(bannerUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBannerControllerAdminDeleteBannerByBannerUuid(bannerUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBannersApi.adminBannerControllerAdminDeleteBannerByBannerUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 배너 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBannerControllerAdminGetBanners(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetBannersOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBannerControllerAdminGetBanners(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBannersApi.adminBannerControllerAdminGetBanners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 배너 수정
         * @param {string} bannerUuid 배너 uuid
         * @param {AdminPatchBannerReqBodyDto} adminPatchBannerReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBannerControllerAdminPatchBannerByBannerUuid(bannerUuid: string, adminPatchBannerReqBodyDto: AdminPatchBannerReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchBannerOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBannerControllerAdminPatchBannerByBannerUuid(bannerUuid, adminPatchBannerReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBannersApi.adminBannerControllerAdminPatchBannerByBannerUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 배너 생성
         * @param {AdminPostBannerReqBodyDto} adminPostBannerReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBannerControllerAdminPostBanner(adminPostBannerReqBodyDto: AdminPostBannerReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPostBannerCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBannerControllerAdminPostBanner(adminPostBannerReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBannersApi.adminBannerControllerAdminPostBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminBannersApi - factory interface
 * @export
 */
export const AdminBannersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminBannersApiFp(configuration)
    return {
        /**
         * 
         * @summary 어드민 배너 삭제
         * @param {AdminBannersApiAdminBannerControllerAdminDeleteBannerByBannerUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBannerControllerAdminDeleteBannerByBannerUuid(requestParameters: AdminBannersApiAdminBannerControllerAdminDeleteBannerByBannerUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminBannerControllerAdminDeleteBannerByBannerUuid(requestParameters.bannerUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 배너 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBannerControllerAdminGetBanners(options?: RawAxiosRequestConfig): AxiosPromise<AdminGetBannersOkDto> {
            return localVarFp.adminBannerControllerAdminGetBanners(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 배너 수정
         * @param {AdminBannersApiAdminBannerControllerAdminPatchBannerByBannerUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBannerControllerAdminPatchBannerByBannerUuid(requestParameters: AdminBannersApiAdminBannerControllerAdminPatchBannerByBannerUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchBannerOkDto> {
            return localVarFp.adminBannerControllerAdminPatchBannerByBannerUuid(requestParameters.bannerUuid, requestParameters.adminPatchBannerReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 배너 생성
         * @param {AdminBannersApiAdminBannerControllerAdminPostBannerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBannerControllerAdminPostBanner(requestParameters: AdminBannersApiAdminBannerControllerAdminPostBannerRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPostBannerCreatedDto> {
            return localVarFp.adminBannerControllerAdminPostBanner(requestParameters.adminPostBannerReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminBannerControllerAdminDeleteBannerByBannerUuid operation in AdminBannersApi.
 * @export
 * @interface AdminBannersApiAdminBannerControllerAdminDeleteBannerByBannerUuidRequest
 */
export interface AdminBannersApiAdminBannerControllerAdminDeleteBannerByBannerUuidRequest {
    /**
     * 배너 uuid
     * @type {string}
     * @memberof AdminBannersApiAdminBannerControllerAdminDeleteBannerByBannerUuid
     */
    readonly bannerUuid: string
}

/**
 * Request parameters for adminBannerControllerAdminPatchBannerByBannerUuid operation in AdminBannersApi.
 * @export
 * @interface AdminBannersApiAdminBannerControllerAdminPatchBannerByBannerUuidRequest
 */
export interface AdminBannersApiAdminBannerControllerAdminPatchBannerByBannerUuidRequest {
    /**
     * 배너 uuid
     * @type {string}
     * @memberof AdminBannersApiAdminBannerControllerAdminPatchBannerByBannerUuid
     */
    readonly bannerUuid: string

    /**
     * 
     * @type {AdminPatchBannerReqBodyDto}
     * @memberof AdminBannersApiAdminBannerControllerAdminPatchBannerByBannerUuid
     */
    readonly adminPatchBannerReqBodyDto: AdminPatchBannerReqBodyDto
}

/**
 * Request parameters for adminBannerControllerAdminPostBanner operation in AdminBannersApi.
 * @export
 * @interface AdminBannersApiAdminBannerControllerAdminPostBannerRequest
 */
export interface AdminBannersApiAdminBannerControllerAdminPostBannerRequest {
    /**
     * 
     * @type {AdminPostBannerReqBodyDto}
     * @memberof AdminBannersApiAdminBannerControllerAdminPostBanner
     */
    readonly adminPostBannerReqBodyDto: AdminPostBannerReqBodyDto
}

/**
 * AdminBannersApi - object-oriented interface
 * @export
 * @class AdminBannersApi
 * @extends {BaseAPI}
 */
export class AdminBannersApi extends BaseAPI {
    /**
     * 
     * @summary 어드민 배너 삭제
     * @param {AdminBannersApiAdminBannerControllerAdminDeleteBannerByBannerUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBannersApi
     */
    public adminBannerControllerAdminDeleteBannerByBannerUuid(requestParameters: AdminBannersApiAdminBannerControllerAdminDeleteBannerByBannerUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminBannersApiFp(this.configuration).adminBannerControllerAdminDeleteBannerByBannerUuid(requestParameters.bannerUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 배너 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBannersApi
     */
    public adminBannerControllerAdminGetBanners(options?: RawAxiosRequestConfig) {
        return AdminBannersApiFp(this.configuration).adminBannerControllerAdminGetBanners(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 배너 수정
     * @param {AdminBannersApiAdminBannerControllerAdminPatchBannerByBannerUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBannersApi
     */
    public adminBannerControllerAdminPatchBannerByBannerUuid(requestParameters: AdminBannersApiAdminBannerControllerAdminPatchBannerByBannerUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminBannersApiFp(this.configuration).adminBannerControllerAdminPatchBannerByBannerUuid(requestParameters.bannerUuid, requestParameters.adminPatchBannerReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 배너 생성
     * @param {AdminBannersApiAdminBannerControllerAdminPostBannerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBannersApi
     */
    public adminBannerControllerAdminPostBanner(requestParameters: AdminBannersApiAdminBannerControllerAdminPostBannerRequest, options?: RawAxiosRequestConfig) {
        return AdminBannersApiFp(this.configuration).adminBannerControllerAdminPostBanner(requestParameters.adminPostBannerReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

